import { ProductSpecCategory } from '@/gql/graphql';
import UntitledIcon from '@payaca/untitled-icons';
import { FC } from 'react';

type ApplianceSpecChips = {
  category: ProductSpecCategory;
  nominalOutputKw?: number | null;
  soundPowerDbA?: number | null;
  type?: string | null;
  domesticHotWaterLitres?: number | null;
};

/**
 * The product specification's headline chips (e.g. `210 L · Unvented`,
 * `8 kW · 42 dB(A) · Monobloc`) joined into a single ` · `-separated string,
 * keyed off the spec's category.
 */
export const specChips = (spec: ApplianceSpecChips): string =>
  (spec.category === 'CYLINDER'
    ? [
        spec.domesticHotWaterLitres != null
          ? `${spec.domesticHotWaterLitres} L`
          : null,
        spec.type,
      ]
    : [
        spec.nominalOutputKw != null ? `${spec.nominalOutputKw} kW` : null,
        spec.soundPowerDbA != null ? `${spec.soundPowerDbA} dB(A)` : null,
        spec.type,
      ]
  )
    .filter(Boolean)
    .join(' · ');

/**
 * A product specification thumbnail, falling back to a generic box icon when
 * the spec has no image.
 */
export const ApplianceThumb: FC<{
  imageUrl?: string | null;
  size?: 'sm' | 'md';
}> = ({ imageUrl, size = 'md' }) => {
  const box = size === 'sm' ? 'h-9 w-9' : 'h-10 w-10';
  const icon = size === 'sm' ? 'h-4 w-4' : 'h-5 w-5';
  return imageUrl ? (
    <img
      src={imageUrl}
      alt=""
      className={`${box} flex-shrink-0 rounded-md border border-gray-200 object-contain`}
    />
  ) : (
    <span
      className={`${box} flex flex-shrink-0 items-center justify-center rounded-md border border-gray-200 bg-gray-100 text-gray-400`}
    >
      <UntitledIcon name="box.3" className={icon} />
    </span>
  );
};
